import React from 'react';
import { connect } from 'react-redux';
import { Form as FinalForm, Field, FormRenderProps } from 'react-final-form';
import { Form, Button } from 'semantic-ui-react';

// Global Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import {
    requestSaveHarvestEvents,
    purgeHarvestEventsUpdates
} from 'services/harvestEvents/actions';

// Global Components
import RadioButtonAdapter from 'components/RadioButtonAdapter';

// Local Constants
import { RETRY, FIX, REVERT } from './constants';

const sharedFieldProps = {
    type: 'radio',
    name: 'resolution',
    component: RadioButtonAdapter
};

interface DispatchProps {
    updateQueryString: Function;
    requestSaveHarvestEvents: Function;
    purgeHarvestEventsUpdates: Function;
}

export type Props = DispatchProps;

export interface FormValues {
    resolution: typeof RETRY | typeof FIX | typeof REVERT;
}

export class HarvestEventsSaveErrorFormComponent extends React.PureComponent<
    Props
> {
    handleClose = (): void => {
        const { props } = this;
        props.updateQueryString({
            error: undefined
        });
    };

    handleSubmit = (values: FormValues): void => {
        const { props } = this;
        const { resolution } = values;

        if (resolution === RETRY) {
            this.handleClose();
            props.requestSaveHarvestEvents();
        }

        if (resolution === FIX) {
            this.handleClose();
        }

        if (resolution === REVERT) {
            this.handleClose();
            props.purgeHarvestEventsUpdates();
        }
    };

    render(): React.ReactElement {
        return (
            <FinalForm
                onSubmit={this.handleSubmit}
                initialValues={{
                    resolution: RETRY
                }}
                render={({
                    handleSubmit
                }: FormRenderProps<FormValues>): React.ReactElement => (
                    <Form onSubmit={handleSubmit}>
                        <Form.Field>
                            Please select how you want to proceed:
                        </Form.Field>
                        <Field
                            {...sharedFieldProps}
                            label="I want to attempt the upload again."
                            value={RETRY}
                        />
                        <Field
                            {...sharedFieldProps}
                            label="I want to go back and try to fix the issue myself."
                            value={FIX}
                        />
                        <Field
                            {...sharedFieldProps}
                            label="I want to revert my changes."
                            value={REVERT}
                        />
                        <Button type="submit" primary>
                            OK
                        </Button>
                    </Form>
                )}
            />
        );
    }
}

export default connect(
    null,
    {
        updateQueryString,
        requestSaveHarvestEvents,
        purgeHarvestEventsUpdates
    }
)(HarvestEventsSaveErrorFormComponent);
